module.exports = __webpack_public_path__ + "sephora-logo-black.b59c2ee78565cbe412f749069e87d7f2.svg";